import React, { Component } from "react";
import { Paper, Subheader, Divider, FlatButton } from "material-ui";

class NotFound extends Component {
  constructor(props) {
    super(props);

    this.state = {
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
      },
    };
  }

  render() {
    let { centerStyle } = this.state.styles;
    return (
      <div className="container">
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
        >
          <div style={centerStyle}>
            <h1>404 Page Not Found</h1>
          </div>
          <Divider />
          <Subheader>Error Details</Subheader>
          <div style={centerStyle}>
            The page you requested could not be displayed.
            <br />
            Route: {this.props.location.pathname || "Undefined"}
          </div>
          <Divider />
          <Subheader>Troubleshooting</Subheader>
          <div style={centerStyle}>
            <p>1. If you typed the address, check for errors</p>
            <p>
              2. Reload the page using the reload button in the browser bar, or
              hit <code>F5</code> on your keyboard
            </p>
            <p>3. Check your internet connection</p>
            <p>
              4. Logout of the app using the menu option in the upper right
              corner, then log back in.
            </p>
            <p>5. For further asistance, contact support@deleoandcompany.com</p>
          </div>
        </Paper>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./app/components/NotFound.js